import { Fragment, useState } from "react";
import ArrowDownIcon from "../../../assets/arrow-down.svg?react";
import RelatedObject from "./RelatedObject";

import Graphic from "@arcgis/core/Graphic";
import "./RelatedObjectGroup.css";
import type Relationship from "@arcgis/core/layers/support/Relationship";

interface RelatedObjectGroupProps {
    isEditing: boolean;
    relatedObjects: { relationship: Relationship; features: Graphic[] }[] | null;
}

const RelatedObjectGroup = (props: RelatedObjectGroupProps) => {
    const { isEditing, relatedObjects } = props;

    const [open, setOpen] = useState(false);

    const getTotalRelatedOjects = () => {
        let total = 0;
        relatedObjects?.forEach((related) => {
            total += related.features.length;
        });
        return total;
    };

    if (!relatedObjects || relatedObjects.length === 0) return null;

    return (
        <>
            <button className="feature-related-object-group" onClick={() => setOpen(!open)}>
                <span className="feature-related-object-group-title">
                    Relaterte objekter ({getTotalRelatedOjects()})
                </span>
                <ArrowDownIcon style={{ rotate: open ? "180deg" : "" }} />
            </button>
            {open && (
                <div>
                    {relatedObjects?.length > 0 ? (
                        <div className="feature-related-object-group-list">
                            {relatedObjects.map((obj) => (
                                <Fragment key={obj.relationship.id}>
                                    <span>{obj.relationship.name}:</span>
                                    <div className="feature-related-object-group-list-item">
                                        {obj.features.map((objFeature) => (
                                            <RelatedObject
                                                key={objFeature.attributes.globalid}
                                                relationship={obj.relationship}
                                                feature={objFeature}
                                                isEditing={isEditing}
                                            />
                                        ))}
                                    </div>
                                </Fragment>
                            ))}
                        </div>
                    ) : (
                        <div className="feature-related-object-group-no-items">Ingen relaterte objekter</div>
                    )}
                </div>
            )}
        </>
    );
};

export default RelatedObjectGroup;
